"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type ExtendVersionRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { extendVersion } from "../api/extendVersion";
import { versioningKeys } from "../queries/keys";

export default function useExtendVersionMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: ExtendVersionRequest) =>
      extendVersion(accessToken, request),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: versioningKeys.all }),
  });
}
